import React, { useState } from "react";
import bcrypt from "bcryptjs";
import { Form, Button, Alert } from "react-bootstrap";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// const RegisterForm = ({ onRegisterSuccess }) => {
const RegisterForm = ({ onRegisterSuccess, switchToLogin }) => {

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState(""); // new field
  // const [token, setToken] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);

    // Basic validation
    if (!username || !email || !password || !confirmPassword ) {
      setMessage("All fields are required.");
      setLoading(false);
      return;
    }

    if (username.length < 4) {
      setMessage("Username must be at least 4 characters.");
      setLoading(false);
      return;
    }

    if (!validateEmail(email)) {
      setMessage("Please enter a valid email.");
      setLoading(false);
      return;
    }

    if (password !== confirmPassword) {
      setMessage("Passwords do not match.");
      setLoading(false);
      return;
    }

    try {
      // ✅ Check if username/email already exists
     const checkRes = await axios.get(`${API_BASE_URL}/api/users/check`, {

       params: { username, email }
     });

     if (checkRes.data.exists) {
       setMessage(checkRes.data.message || "Username or email already exists.");
       setLoading(false);
       return;
     }

      // Hash the password
      // const hashedPassword = await bcrypt.hash(password, 10);

      // Prepare data
      const userData = {
        username,
        email,
        password: password,
      };

      // Send to backend API
      const res = await axios.post(`${API_BASE_URL}/api/users/register`, userData);
        if (res.data.success) {
        setSuccess(true); // ✅ mark success
        setMessage("Registration successful! 🎉");

        // Clear fields
        setUsername("");
        setEmail("");
        setPassword("");
        setConfirmPassword("");
        // setToken("");

        // Optional: close modal after 2 seconds
        setTimeout(() => {
          if (onRegisterSuccess) onRegisterSuccess();
        }, 2000);
      } else {
        setMessage(res.data.message || "Registration failed.");
      }
    } catch (err) {
      console.error(err);
      setMessage(err.response?.data?.error || "Registration failed.");
    }

    setLoading(false);
  };

  return (
    <Form onSubmit={handleSubmit}>
      {message && (
        <Alert
          variant={message.includes("successful") ? "success" : "danger"}
          onClose={() => setMessage("")}
          dismissible
        >
          {message}
        </Alert>
      )}

      <Form.Group className="mb-3" controlId="username">
        <Form.Label>Username</Form.Label>
        <Form.Control
          type="text"
          value={username}
          placeholder="Enter Username"
          onChange={(e) => setUsername(e.target.value)}
          required
        />
      </Form.Group>

      <Form.Group className="mb-3" controlId="email">
        <Form.Label>Email</Form.Label>
        <Form.Control
          type="email"
          value={email}
          placeholder="Enter Email"
          onChange={(e) => setEmail(e.target.value)}
          required
        />
      </Form.Group>

      <Form.Group className="mb-4" controlId="password">
        <Form.Label>Password</Form.Label>
        <Form.Control
          type="password"
          value={password}
          placeholder="Enter Password"
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </Form.Group>

      <Form.Group className="mb-4" controlId="confirmPassword">
        <Form.Label>Confirm Password</Form.Label>
        <Form.Control
          type="password"
          value={confirmPassword}
          placeholder="Confirm Password"
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
      </Form.Group>

      {/* <Form.Group className="mb-4" controlId="token">
        <Form.Label>BaseSpace Token</Form.Label>
        <Form.Control
          type="text"
          value={token}
          placeholder="Enter BaseSpace Token"
          onChange={(e) => setToken(e.target.value)}
          required
        />
      </Form.Group> */}

      <Button className="w-100" type="submit" variant="primary" disabled={loading}>
        {loading ? "Registering..." : "Register"}
      </Button>

      <div className="text-center mt-3">
        <small>
          Already have an account?{" "}
          <span
            onClick={switchToLogin}
            style={{ color: "#0d6efd", cursor: "pointer" }}
          >
            Login
          </span>
        </small>
      </div>

    </Form>
  );
};

export default RegisterForm;